<template>
  <section>
    <div
      v-for="(message, index) in feed"
      :key="index"
    >
      <message-own
        v-if="message.userCode === ldap && message.id !== ''"
        v-bind="message"
      />
      <message-foreign
        v-else-if="message.id !== ''"
        v-bind="message"
      />
    </div>
  </section>
</template>

<script>
import MessageForeign from '@/components/messages/MessageForeign'
import MessageOwn from '@/components/messages/MessageOwn'

export default {
  name: 'MessagesList',
  components: {
    MessageForeign,
    MessageOwn
  },
  props: ['feed'],
  data () {
    return {
      ldap: null
    }
  },
  watch: {
    feed: function (changes) {
      if (changes) {
        this.$eventBus.$emit('messagesScrollToBottom')
      }
    },
    deep: true
  },
  mounted () {
    this.ldap = this.$store.getters['user/status'].info.login
    this.$eventBus.$emit('messagesScrollToBottom')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/messages/MessagesList.vue